// removed by extract-text-webpack-plugin
module.exports = {"grey":"#707070","light-grey":"#d4d4d4","background-grey":"#f6f6f6","medium-grey":"#9f9f9f","white":"#ffffff","mapUi":"_3yFLcmWgDzAw4lbkLGbQ-O","mapControl":"_1xRn7YmoNz6JEvYZjOeHd6","disable":"_3DzA7_YXhmc9ubQo64tR19"};


//////////////////
// WEBPACK FOOTER
// ./src/uis/components/Map/MapControls/MapControls.css
// module id = 1281
// module chunks = 0